var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVariableSmall = function SvgVariableSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2.5a.5.5 0 0 0 0-1H1V2h2.5a.5.5 0 0 0 0-1H1Zm9.29 3a1 1 0 0 0-.868.504L8.064 6.88 7.09 4.606A1 1 0 0 0 6.171 4H4.5a.5.5 0 0 0 0 1H6.17l1.272 2.968L5.71 11H4v-.5a.5.5 0 0 0-1 0v.5a1 1 0 0 0 1 1h1.71a1 1 0 0 0 .868-.504L7.936 9.12l.975 2.274A1 1 0 0 0 9.83 12H11.5a.5.5 0 0 0 0-1H9.83L8.558 8.032 10.29 5H12v.5a.5.5 0 0 0 1 0V5a1 1 0 0 0-1-1h-1.71ZM16 2a1 1 0 0 0-1-1h-2.5a.5.5 0 0 0 0 1H15v12h-2.5a.5.5 0 0 0 0 1H15a1 1 0 0 0 1-1V2Z",
    clipRule: "evenodd"
  })));
};
export default SvgVariableSmall;